<template>
  <!-- 弹框 -->
  <Modal
    v-model="isShow"
    width="700"
    title="充值"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListForm')"
  >
    <Form
      ref="editListForm"
      label-position="right"
      :label-width="120"
      :rules="ruleValidate"
      :model="editListForm"
    >
      <FormItem>
        <Alert type="success">对公账号：中易服信息科技有限公司 XX银行 622222222222</Alert>
      </FormItem>
      <FormItem label="充值金额"
        prop="price"
        label-for="price"
      >
        <Input
          placeholder="请输入金额"
          element-id="price"
          v-model="editListForm.price"
        />
      </FormItem>
      <FormItem
        label="开户行"
        prop="bank_name"
        label-for="bank_name"
      >
        <Input
          placeholder="请输入开户行"
          element-id="bank_name"
          v-model="editListForm.bank_name"
        />
      </FormItem>
      <FormItem label="对公账户"
        prop="bank_account"
        label-for="bank_account"
      >
        <Input
          placeholder="请输入对公账户"
          element-id="bank_account"
          v-model="editListForm.bank_account"
        />
      </FormItem>
      <FormItem label="流水单号"
        prop="flow_no"
        label-for="flow_no"
      >
        <Input
          placeholder="请输入流水单号"
          element-id="flow_no"
          v-model="editListForm.flow_no"
        />
      </FormItem>
      <FormItem>
        <span>提交后在1-2个工作日内完成充值</span>
      </FormItem>
      <FormItem
        label="付款凭证"
        label-for="img_urls"
      >
        <UploadImg
          :defaultList="defaultImgList"
          @on-change="editListForm.img_urls = $event"
        />
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import UploadImg from '@/components/UploadImg'
export default {
  components: {
    UploadImg
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isShow: this.value,
      loading: true,
      defaultImgList: [],
      editListForm: {
        price: '',
        bank_name: '',
        bank_account: '',
        flow_no: '',
        img_urls: []
      },
      ruleValidate: {
        price: [
          { required: true, message: '请输入充值金额', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bank_account: [
          { required: true, message: '请输入对公账号', trigger: 'blur' }
        ],
        flow_no: [
          { required: true, message: '请输入对流水单号', trigger: 'blur' }
        ]
        // img_urls: [
        //   { required: true, message: '最少提交一张凭证', trigger: 'blur' }
        // ]
      }
    }
  },
  watch: {
    value (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    editList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          for (let obj in this.editListForm) {
            if (obj === 'img_urls') {
              let arr = []
              this.editListForm[obj].forEach(val => {
                arr.push(val.url)
              })
              if (arr.length <= 0) {
                this.$Message.error('请上传付款凭证图')
                return
              }
              this.editListForm[obj] = arr
            }
          }
          let data = {
            ...this.editListForm
          }
          let url = '/agent/account/recharge'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              this.$Message.success('充值成功')
              this.isShow = false
              this.$emit('on-success')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.defaultImgList = []
      this.editListForm = {
        price: '',
        bank_name: '',
        bank_account: '',
        flow_no: '',
        img_urls: [''],
        agent_level_id: 1
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agAgentManage/AgAgentRechargeModal.vue